import { render } from "./itemsList.vue?vue&type=template&id=c2605cb2"
import script from "./itemsList.vue?vue&type=script&lang=js"
export * from "./itemsList.vue?vue&type=script&lang=js"

import "./itemsList.vue?vue&type=style&index=0&id=c2605cb2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__